/*
  This file has been mostly generated by AI (~85% by line count)
*/

import { createFileRoute, useLoaderData } from '@tanstack/react-router'
import { InspectView } from '../../../Components/InspectView'

export const Route = createFileRoute('/illustrations/$illustrationId/')({
  component: IllustrationView
})

function IllustrationView() {
  const illustration = useLoaderData({ from: '/illustrations/$illustrationId' })

  if (!illustration) {
    return (
      <div>
        <InspectView />
      </div>
    )
  }

  return <InspectView illustration={illustration} />
}
